"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcInputNumber(props) {
  var className = props.className,
    id = props.id,
    disabled = props.disabled,
    onPressEnter = props.onPressEnter,
    value = props.value,
    min = props.min,
    max = props.max,
    placeholder = props.placeholder,
    onChange = props.onChange,
    status = props.status,
    showCount = props.showCount,
    allowClear = props.allowClear;
  return /*#__PURE__*/_react["default"].createElement(_lib.InputNumber, {
    style: {
      width: '100%'
    },
    placeholder: placeholder,
    onChange: onChange,
    disabled: disabled,
    value: value,
    className: className,
    allowClear: allowClear,
    id: id,
    showCount: showCount,
    status: status,
    onPressEnter: onPressEnter
  });
}
var _default = ArcInputNumber;
exports["default"] = _default;